export class MechanicValidator {
    constructor(playerValidators, mapValidator){
        this.playerValidators = new Map();
        for (const playerValidator of playerValidators){
            this.playerValidators.set(playerValidator.color, playerValidator);
        }
        this.mapValidator = mapValidator;
    }
}
